//
//
//
//
//
//
//
//
//
//
//

import navBars from './pages/components/nav.vue'
import nav from './pages/components/nav.vue'

export default {
  name: 'App',
  components:{
    navBars
  },
  data(){
      return{

      }
  },
}



// WEBPACK FOOTER //
// ./src/App.vue